import UdeskLocales from 'UdeskLocales';
import React, { memo, useEffect, useState } from 'react';
import { Select } from 'udesk-ui';
import { SelectProps } from 'antd';
import { postAgentGroupsDeps } from 'src/api/agentGroups/deps';
import { Agent1 } from 'src/api/types';

interface TemplateProps<T extends number | number[]> extends SelectProps<T> {
    agentGroupIds?: number | number[];
    agentDepartmentIds?: number | number[];
}

const Template: <T extends number | number[]>(
    props: TemplateProps<T>
) => React.ReactElement | null = memo((props) => {
    const { agentGroupIds, agentDepartmentIds, ...restProps } = props;

    const [agents, setAgents] = useState<Agent1[]>();

    useEffect(() => {
        const groupIds = Array.isArray(agentGroupIds)
            ? agentGroupIds
            : agentGroupIds
            ? [agentGroupIds]
            : agentGroupIds;

        const departmentIds = Array.isArray(agentDepartmentIds)
            ? agentDepartmentIds
            : agentDepartmentIds
            ? [agentDepartmentIds]
            : agentDepartmentIds;

        postAgentGroupsDeps({
            agentGroupIds: groupIds as number[],
            agentDepartmentIds: departmentIds as number[],
        }).then((res) => {
            setAgents(res.data);
        });
    }, [agentDepartmentIds, agentGroupIds]);

    return (
        <Select
            options={agents?.map((a) => {
                return {
                    label: a.agentName,
                    value: a.agentNo!,
                };
            })}
            placeholder={
                /* 请选择客服 */ UdeskLocales['current'].components.agentSelect.index
                    .pleaseSelectCustomerService
            }
            filterOption={(input, opntion) => {
                const label = (opntion?.label as string) || '';
                return label.toLowerCase().includes(input.toLowerCase());
            }}
            {...restProps}
        />
    );
});

export default Template;
